<template>
    <cadastro-simples-list
        endpoint="situacao-requerimento"
        rota-base="/admin/situacao-requerimento"
        titulo="SITUAÇÕES DE REQUERIMENTO"
        titulo-singular="Situação de Requerimento"
        :colunas-extras='[{"campo":"cor","label":"Cor (hex)","tipo":"string","maxLength":9,"descricao":"Ex.: #67c23a"},{"campo":"ordem","label":"Ordem","tipo":"int"}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
